module.exports = __webpack_public_path__ + "static/amazon2-445417f62e2b36005126c318002b1958.png";